export function formatPublishValidationDescription(
  errors: Array<{ message?: string }> | undefined,
): string {
  const messages = (errors ?? [])
    .map((e) => e.message)
    .filter((m): m is string => Boolean(m));
  if (messages.length > 1) {
    return `${messages[0]} (+${messages.length - 1} more)`;
  }
  return messages[0] ?? 'Form failed validation.';
}
